import React from 'react';
import Icon from '../../../components/AppIcon';

const TimeframeToggle = ({ activeTimeframe, onTimeframeChange, timeframes }) => {
  return (
    <div className="flex items-center gap-2 overflow-x-auto custom-scrollbar pb-2 md:pb-0">
      {timeframes?.map((timeframe) => (
        <button
          key={timeframe?.value}
          onClick={() => onTimeframeChange(timeframe?.value)}
          className={`
            px-3 md:px-4 h-9 md:h-10 rounded-lg flex items-center gap-2 transition-smooth flex-shrink-0
            ${activeTimeframe === timeframe?.value
              ? 'bg-primary text-primary-foreground shadow-glow-primary'
              : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
            }
          `}
        >
          <Icon name={timeframe?.icon} size={16} />
          <span className="text-xs md:text-sm font-medium whitespace-nowrap">{timeframe?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TimeframeToggle;